import { Actions } from '../actions/enums';

export function initializeMenuHandoff(): void {
  if (!globalThis.ikea?.pubsub || globalThis.ikea?.mvAgent?.profilePagesFragmentLive) {
    return;
  }
  const alreadyGotten = globalThis.ikea.pubsub.eventsHistory?.some(
    (x) =>
      x.event === Actions.PROFILE_NEW_VERSION_RUNNING ||
      (x.namespace === 'PROFILE' && x.event === 'NEW_VERSION_RUNNING'),
  );
  globalThis.ikea.mvAgent.profilePagesFragmentLive = alreadyGotten ?? false;
  globalThis.ikea.pubsub.subscribe(Actions.PROFILE_NEW_VERSION_RUNNING, () => {
    globalThis.ikea.mvAgent.profilePagesFragmentLive = true;
  });
}
